/* eslint-disable no-dupe-keys */
export default {
  membership: {
    name: '会员管理',
    // 属性（一般与对象内容匹配）
    prop: {
      membership_product: '会员类型',
      month_card: '月卡',
      quarterly_card: '季卡',
      annual_card: '年卡',
      terms_url: '会员条款',
      member_day_discount_stacking_type: '优惠叠加类型',
      multiple_of_reward_point: '积分翻倍',
      reward_count: '发放数量',
      member_day: '会员优惠日',
      member_day_service_discount_rate: '服务费折扣',
      coupon_definitions: '优惠劵'
    },
    // Enum的属性
    member_day_discount_stacking_types: {
      exclusive: '优惠互斥',
      unrestricted: '优惠叠加'
    },
    // Boolean的属性
    // 占位提示
    // 标签
    detail_tags: {
      vip_members: '会员成员',
      membership: '会员配置',
      vip_charge_stations: '会员电站',
      orders: '充电订单'
    },
    // 标题
    titles: {
      base_info: ' 会员基本信息',
      member_day_discount: '会员日优惠',
      terms_url: '会员条款说明',
      membership: '会员权益',
      coupon_definitions: '优惠劵配置',
      multiple_of_reward_point: '积分配置',
      coupon_reward: '优惠券奖励',
      point_reward: '积分奖励',
      member_day: '会员优惠日配置'
    },
    member_days: {
      0: '星期日',
      1: '星期一',
      2: '星期二',
      3: '星期三',
      4: '星期四',
      5: '星期五',
      6: '星期六'
    },
    membership_product: {
      price: '售价',
      market_price: '市场价'
    },
    tips: {
      multiple_of_reward_point: '若设置为2,则表示参与活动获得的积分x2倍',
      member_day: '在会员日00:00后启动，并在23:59前结束的订单才能享受会员日优惠'
    },
    labels: {
      total_months: '月份数'
    }
  }
}
